const cms = (() =>{
    const initBlock = el => 
        el.querySelectorAll('a').forEach(a => {
            if (a.classList.contains('btn')){
                a.classList.add('button')
            }
            else
            {
                a.classList.add('text-link');
            }
        });
    return {initBlock};
})();
ControlBinders.register(`.cms`, el => cms.initBlock(el));